import React from 'react';
import { Image } from 'react-bootstrap';
import PcodImage from '../Images/PCOD Banner.png';
// import PcodImage from '../Images/PCOS Banner.jpg';
import './Nutrition.css';

function PCOD() {
  return (
    <div className="bg-page">
      <Image src={PcodImage} fluid className="Banner-Img" />

      <div className="form-section">
        <div className="form-wrapper">
          <iframe
            src="https://docs.google.com/forms/d/e/1FAIpQLSd6g4OyPGld4GPJqKgCGx432lll2HlJVdqf5Bv3JE2v3_FLdw/viewform?embedded=true"
            className="google-form"
            frameBorder="0"
            marginHeight="0"
            marginWidth="0"
            title="Nutrition Form"
          >
            Loading...
          </iframe>
        </div>
      </div>
    </div>
  );
}

export default PCOD;